// extracted by mini-css-extract-plugin
export var areaCard = "ServicesBlocks-module--area-card--03e90";
export var areaGrid = "ServicesBlocks-module--area-grid--2899c";
export var contact = "ServicesBlocks-module--contact--a2376";
export var content = "ServicesBlocks-module--content--01300";
export var readMore = "ServicesBlocks-module--read-more--ea6a0";
export var title = "ServicesBlocks-module--title--fbb4c";